// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"73fbfa11","977":"f011eecf"}[chunkId] + ".chunk.js";
};